export const TOOLTIP_TYPES = {
  TOTAL: "TOTAL",
  AVERAGE: "AVERAGE"
}